module.exports = __webpack_public_path__ + "img/box_bg_3.b59823a7.gif";